import type { NsurePlanOverview } from "Infrastructure/ApiZfp/Schema/nsurePlanOverview";
import type { Dispatch, ReactNode, SetStateAction } from "react";
import { createContext, useState } from "react";
import type { NsureSelection } from "./InvestmentsNsureSelectionTypes";
import { EMPTY_NSURE_EVALUATION, type NsureEvaluation, useNsureEvaluation } from "./useNsureEvaluation";

export * from "./InvestmentsNsureSelectionTypes";

export const NsureSelectionContext = createContext<{
  selection: NsureSelection;
  setSelection: Dispatch<SetStateAction<NsureSelection>>;
  nsurePlan: NsurePlanOverview | undefined;
  showInstrumentSearch: boolean;
  setShowInstrumentSearch: Dispatch<SetStateAction<boolean>>;
  evaluation: NsureEvaluation;
}>({
  selection: null,
  setSelection: () => {},
  nsurePlan: undefined,
  showInstrumentSearch: false,
  setShowInstrumentSearch: () => {},
  evaluation: EMPTY_NSURE_EVALUATION,
});

export const NsureSelectionProvider = ({
  children,
  nsurePlan,
  initialSelection,
  initialShowInstrumentSearch,
}: {
  readonly children: ReactNode;
  readonly nsurePlan: NsurePlanOverview;
  readonly initialSelection: NsureSelection;
  readonly initialShowInstrumentSearch?: boolean;
}) => {
  const [selection, setSelection] = useState<NsureSelection>(initialSelection ?? null);
  const [showInstrumentSearch, setShowInstrumentSearch] = useState(initialShowInstrumentSearch ?? false);
  const evaluation = useNsureEvaluation(selection, nsurePlan);

  return (
    <NsureSelectionContext.Provider
      value={{
        selection,
        setSelection,
        nsurePlan,
        showInstrumentSearch,
        setShowInstrumentSearch,
        evaluation,
      }}
    >
      {children}
    </NsureSelectionContext.Provider>
  );
};
